enum Listing {
    active = "active",
    pending = "pending",
    hidden = "hidden"
}
export default Listing;
